module.exports = "<app-route-edit-relations route=$ctrl.route on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-route-edit-relations> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/relations/template.html
// module id = 479
// module chunks = 0